import { __awaiter, __generator, __values } from "tslib";
export var STATE;
(function (STATE) {
    STATE[STATE["USER_STATE"] = 0] = "USER_STATE";
    STATE[STATE["USER_DATA"] = 1] = "USER_DATA";
    STATE[STATE["BOOKMARK_INFORMATION"] = 2] = "BOOKMARK_INFORMATION";
    STATE[STATE["TRANSLATOR"] = 3] = "TRANSLATOR";
    STATE[STATE["INPUT_VALUE_SETUP_PACKAGE"] = 4] = "INPUT_VALUE_SETUP_PACKAGE";
})(STATE || (STATE = {}));
var StateHelper = /** @class */ (function () {
    function StateHelper() {
        this.stateMap = new Map();
    }
    Object.defineProperty(StateHelper, "instance", {
        get: function () {
            if (!this.INSTANCE) {
                this.INSTANCE = new StateHelper();
            }
            return this.INSTANCE;
        },
        enumerable: false,
        configurable: true
    });
    StateHelper.prototype.readyStates = function () {
        var states = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            states[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, Promise, function () {
            var states_1, states_1_1, state, states_2, states_2_1, state, e_1_1;
            var e_2, _a, e_1, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        try {
                            for (states_1 = __values(states), states_1_1 = states_1.next(); !states_1_1.done; states_1_1 = states_1.next()) {
                                state = states_1_1.value;
                                if (!this.stateMap.has(state)) {
                                    this.pushState(state);
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (states_1_1 && !states_1_1.done && (_a = states_1.return)) _a.call(states_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, 7, 8]);
                        states_2 = __values(states), states_2_1 = states_2.next();
                        _c.label = 2;
                    case 2:
                        if (!!states_2_1.done) return [3 /*break*/, 5];
                        state = states_2_1.value;
                        return [4 /*yield*/, this.stateMap.get(state).promise];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        states_2_1 = states_2.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _c.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (states_2_1 && !states_2_1.done && (_b = states_2.return)) _b.call(states_2);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/, new Promise(function (resolve) { return resolve(); })];
                }
            });
        });
    };
    StateHelper.prototype.pushState = function (state) {
        var resolver;
        var promise = new Promise(function (res) { return resolver = res; });
        this.stateMap.set(state, { promise: promise, resolver: resolver });
    };
    StateHelper.prototype.resolveState = function (state) {
        if (!this.stateMap.has(state)) {
            this.pushState(state);
        }
        this.stateMap.get(state).resolver();
    };
    return StateHelper;
}());
export { StateHelper };
